var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 23.5C2.19167 23.5 1.64236 23.2715 1.18542 22.8145C0.728472 22.3576 0.5 21.8083 0.5 21.1666V4.83328C0.5 4.19162 0.728472 3.64231 1.18542 3.18537C1.64236 2.72842 2.19167 2.49995 2.83333 2.49995H13.2458L10.9125 4.83328H2.83333V21.1666H19.1667V13.0583L21.5 10.725V21.1666C21.5 21.8083 21.2715 22.3576 20.8146 22.8145C20.3576 23.2715 19.8083 23.5 19.1667 23.5H2.83333ZM7.5 16.5V11.5416L18.2042 0.837451C18.4375 0.604118 18.7 0.429118 18.9917 0.312451C19.2833 0.195785 19.575 0.137451 19.8667 0.137451C20.1778 0.137451 20.4743 0.195785 20.7563 0.312451C21.0382 0.429118 21.2958 0.604118 21.5292 0.837451L23.1625 2.49995C23.3764 2.73328 23.5417 2.99092 23.6583 3.27287C23.775 3.55481 23.8333 3.84162 23.8333 4.13328C23.8333 4.42495 23.7799 4.71176 23.6729 4.9937C23.566 5.27565 23.3958 5.53329 23.1625 5.76662L12.4583 16.5H7.5ZM9.83333 14.1666H11.4667L18.2333 7.39995L17.4167 6.58328L16.5708 5.76662L9.83333 12.5041V14.1666Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit_square.4889c3e3c06b5187cc885b706130fa52.svg";
export { ForwardRef as ReactComponent };